import { TooltipRenderProps } from 'react-joyride'
import { classed } from '@tw-classed/react'

interface CustomStep {
  content: string
  imagePlace: 'top-right' | 'bottom' | 'left-top' | 'left' | 'left-end'
  imageClassname?: string
  edmanImageSize?: 'large' | 'medium'
  nextStepText?: string
  disableButton: boolean
  styles?: {
    tooltip?: React.CSSProperties
  }
}

const ClassedImg = classed('img', {
  base: 'absolute size-[110px] rounded-full object-cover bg-yellow5',
  variants: {
    imagePlace: {
      'top-right': 'top-[-92px] right-[-12px]',
      'top-center': 'left-[50%] top-[-190px] -translate-x-1/2',
      bottom: 'bottom-[-72px] left-[-16px]',
      'left-top': 'top-[-92px] left-[-12px]',
      'left-end': 'bottom-[-36px] left-[-92px]',
      right: 'right-[-100px] top-[0px]',
      left: 'left-[-96px] top-[0px]',
    },
    edmanImageSize: {
      large: 'size-[204px]',
      medium: 'size-[110px]',
    },
  },
})

const JoyrideButton = classed('button', {
  base: 'absolute bottom-10 right-10 h-28 rounded-24 border-0 bg-gradient-to-b from-[#E2E6F3] to-[#B1BDDF] px-12 text-13 font-extrabold leading-none text-black outline-none',
})

const TooltipWrapper = classed('div', {
  base: 'relative rounded-16 bg-white p-18 shadow-tooltip pb-40 xl:pb-16 max-w-[calc(100vw-64px)] mx-auto',
})

const TooltipContent = classed('div', {
  base: 'text-16 font-semibold font-nunito',
})

export const JoyrideCustomTooltip = ({
  primaryProps,
  tooltipProps,
  step,
}: TooltipRenderProps) => {
  const customStep = step as unknown as CustomStep

  return (
    <TooltipWrapper
      {...tooltipProps}
      style={{
        ...customStep.styles?.tooltip,
      }}
    >
      <TooltipContent>{customStep.content}</TooltipContent>
      {customStep.content && !customStep.disableButton && (
        <JoyrideButton {...primaryProps}>
          {customStep.nextStepText ?? 'Дальше'}
        </JoyrideButton>
      )}

      <ClassedImg
        imagePlace={customStep.imagePlace}
        edmanImageSize={customStep.edmanImageSize}
        className={customStep.imageClassname}
        src={'/images/new_edman.png'}
      />
    </TooltipWrapper>
  )
}
